import script from "./bread.vue?vue&type=script&setup=true&lang=js"
export * from "./bread.vue?vue&type=script&setup=true&lang=js"

import "./bread.vue?vue&type=style&index=0&id=04254cd0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04254cd0"]])

export default __exports__